import React from 'react';
import { SpaceBetween, StyledContainer } from '../../../components/container/styles';
import { TextLarge } from '../../../components/text';
import { CardTheme } from '../../../components/card';
import { ButtonTheme } from '../../../components/buttons';
import { ContainerButton } from '../../../styles/global-style';
import { ResponsivePageLayout } from '../../../components/page/responsive-layout/ResponsivePageLayout';
import { Icon } from '../../../resources';
import { useGetRegList } from './hooks/useGetRegList';
import { InfoRegistration } from './views/InfoRegistration';
import { columns, exportHeaders } from './columns';
import ButtonExcelEmbedded from '../../../components/report-excel/ButtonExcelEmbedded';
import { Spin } from 'antd';

export const RegistrationList = () => {
  const {
    formSearch,
    dataFull,
    isLoadingFull,
    dataDate,
    isLoading,
    onSearch,
    searchType,
    formSearchObj,
    handleDelete,
    transformDataForExcel,
    linkToRegistrationAdd,
    isloadingToDel,
  } = useGetRegList();

  return (
    <Spin spinning={isloadingToDel}>
      <StyledContainer>
        <TextLarge text="รายงานการลงทะเบียน" />
        <CardTheme>
          <ContainerButton right>
            <ButtonTheme useFor="WARRANTY" onClick={() => linkToRegistrationAdd()} />
          </ContainerButton>
          <ResponsivePageLayout
            searchLayout={{
              title: 'ค้นหารายการลงทะเบียน',
              icon: <Icon.Todo />,
              formSearch,
              useFormParam: formSearchObj,
              onSearch: formSearchObj.handleSubmit(onSearch),
              onClear: formSearchObj.reset,
            }}
            content={<InfoRegistration />}
            tableLayout={{
              columns: columns({ handleDelete }),
              dataSource: searchType === 'search' ? dataFull : dataDate,
              hasPagination: true,
              loading: isLoading || isLoadingFull,
              extraContent: (
                <SpaceBetween>
                  <ContainerButton right>
                    <ButtonExcelEmbedded
                      title="Export"
                      filename="รายงานการลงทะเบียน"
                      header={exportHeaders}
                      data={transformDataForExcel(searchType === 'search' ? dataFull : dataDate)}
                    />
                  </ContainerButton>
                </SpaceBetween>
              ),
            }}
          />
        </CardTheme>
      </StyledContainer>
    </Spin>
  );
};
